<template>
    <div class="text-setting__options">
        <button
            v-for="device in devices"
            :key="device.name"
            class="text-setting__option"
            :class="getButtonClass(device.name)"
            @click="onDeviceClick(device)"
        >
            <font-awesome-icon :icon="['fal', device.icon]" />
        </button>

        <button
            class="text-setting__option text-setting__option--hover"
            :class="hoverClass"
            @click="onHoverClick"
        >
            HOV
        </button>
    </div>
</template>

<script>
import { getDevices } from '@/utils/devices';
import { STATE_CLASSES } from '@/data/constants/classes';

export default {
    name: 'settings-responsive-options',

    data() {
        return {
            devices: getDevices(),
            selectedDevice: getDevices()[0],
            selectedState: '',
        };
    },

    computed: {
        hoverClass() {
            return this.selectedState === 'hover' ? [STATE_CLASSES.SELECTED] : '';
        },
    },

    methods: {
        onDeviceClick(device) {
            this.selectedDevice = device;
            this.update();
        },

        onHoverClick() {
            this.selectedState = this.selectedState ? '' : 'hover';
            this.update();
        },

        getButtonClass(deviceName) {
            return {
                [STATE_CLASSES.SELECTED]: deviceName === this.selectedDevice.name,
            };
        },

        update() {
            this.$emit('input', {
                device: this.selectedDevice,
                state: this.selectedState,
            });
        },
    },
};
</script>
